import React from 'react';
import DocumentMeta from 'react-document-meta';

interface NoIndexProps {
  title?: string;
}

const NoIndex: React.FC<NoIndexProps> = ({ title }) => {
  const metaObj: any = {
    ...(title ? { title } : {}),
    meta: {
      name: {
        robots: 'noindex,nofollow,noarchive,noimageindex',
        googlebot: 'noindex,nofollow,noarchive,noimageindex',
      },
    },
  };
  return <DocumentMeta {...metaObj} />;
};

export default NoIndex;
